import React from 'react';
import './css/LoadingIcon.css';

export const LoadingIcon = (props) => (<div {...props} className='loadingIcon' />);